export enum CourseType {
  Course,
  Topic,
}
